import { BackgroundColor } from '../../Molecules/ContainerArrow/ContainerArrow.model';

export const sectionBgColours = Object.freeze(['red', 'blue', 'plum'] as Array<
  keyof BackgroundColor
>);
